import { render, staticRenderFns } from "./PurchaseOrderDisplaySettings.vue?vue&type=template&id=023af04b"
import script from "./PurchaseOrderDisplaySettings.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderDisplaySettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports